import { lookup } from '@npc/copy'

import { t, type CopyId } from './index'

/**
 * 项目七模块文案 overlay。
 *
 * generate-copy 之后走 `@npc/copy`；还没进生成物时用与 yaml 逐字相同的桥。
 */

export const PJSHELL = {
  'pjshell.readiness.registered': '注册到 NPC',
  'pjshell.readiness.heartbeat': '收到首次心跳',
  'pjshell.readiness.execution': '命令执行验证',
  'pjshell.readiness.ready': '可部署',
  'pjshell.readiness.pending': '接入未完成',
  'pjshell.readiness.continue': '继续接入',
  'pjshell.readiness.verify': '重新验证',
  'pjshell.readiness.running': '正在安装并检查…',
  'pjshell.readiness.ssh_unavailable': '连接验证失败，请检查现有连接信息。',
  'pjshell.readiness.installer_unavailable': '平台未配置探针安装服务。',
  'pjshell.readiness.install_timeout': '安装超时，可重试；平台会重新检查下载与启动。',
  'pjshell.readiness.check_failed': '这次检查未完成，请重试。',
  'pjshell.readiness.install_failed': '探针安装失败，可重试或查看机器详情。',
  'pjshell.readiness.awaiting_heartbeat': '尚未收到有效心跳。再次继续接入会尝试补装探针；仍失败可查看连接信息。',
  'pjshell.readiness.execution_failed': '命令执行验证失败，请检查机器的执行权限。',
  'pjshell.readiness.agent_only': '此机器仅支持探针托管，不适用 SSH 部署验证。',
  'pjshell.readiness.scope': '验证平台 SSH 命令通道；具体应用的部署配置仍需单独检查。',
  'pjshell.readiness.validity': '验证有效期 15 分钟；心跳失联后自动取消可部署状态。',
  'pjshell.readiness.complete': '已完成：',
  'pjshell.readiness.waiting': '待完成：',
  'pjshell.readiness.details': '查看连接信息',

  'pjshell.unverified': '未核验',
  'pjshell.fact.uncollected': '未采集',
  'pjshell.fact.unconfigured': '未配置',
  'pjshell.fact.probe_failed': '采集失败',
  'pjshell.pending_item': '还没弄的',
  'pjshell.env.test': '测试',
  'pjshell.env.production': '正式',
  'pjshell.env.promote': '搬到正式',
  'pjshell.env.promote.title': '把测试发到正式？',
  'pjshell.env.promote.body':
    '搬的是测试上跑着的那个包本身，不是重新打一个。所以测试上是什么样，正式上就是什么样。',
  'pjshell.env.promote.note': '不会重新打包 —— 同一个包直接换过去',
  'pjshell.env.no_bundle': '还没有可搬的包',
  'pjshell.env.status.ready': '核过了',
  'pjshell.env.status.failed': '没过',
  'pjshell.env.status.rolled_back': '已经退回去了',
  'pjshell.env.subtitle': '两套环境：测试用来看效果，正式是用户在用的。',
  'pjshell.env.configure': '配置环境',
  'pjshell.env.configure.title': '配置环境资料',
  'pjshell.env.configure.test_title': '配置测试环境',
  'pjshell.env.configure.body':
    '选择环境和机器。域名、证书有什么就填什么，没有可以留空；部署时再检查是否满足上线条件。',
  'pjshell.env.configure.test_body':
    '测试环境只要选择机器。域名和证书有就填，我会一起核验；没有就直接使用机器地址。',
  'pjshell.env.configure.domain': '域名',
  'pjshell.env.configure.domain_optional': '域名（选填）',
  'pjshell.env.configure.target': '放到哪里',
  'pjshell.env.configure.machine': '使用哪台机器',
  'pjshell.env.configure.files': '证书文件',
  'pjshell.env.configure.files_optional': '证书文件（选填）',
  'pjshell.env.configure.files_hint': '可以选整个证书包，或者同时选择证书和私钥。我不会显示或下载私钥。',
  'pjshell.env.configure.submit': '保存资料',
  'pjshell.env.configure.done': '环境资料已保存，尚未满足的部署条件会继续显示在页面上。',
  'pjshell.env.configure.ready': '环境资料已保存，这台机器当前可以部署。',
  'pjshell.env.configure.test_done': '测试环境已保存，机器还没有达到可部署状态。',
  'pjshell.env.configure.test_ready': '机器已经核过，可以部署到测试环境。',
  'pjshell.env.configure.pick': '选择证书包',
  'pjshell.env.configure.pick_folder': '选择整个文件夹',
  'pjshell.env.domain.registered': '已登记',
  'pjshell.env.domain.verified': '已解析',
  'pjshell.env.domain.waiting': '等待解析',
  'pjshell.env.certificate.stored': '已安全保管',
  'pjshell.env.address': '地址',
  'pjshell.env.version': '版本',
  'pjshell.env.when': '什么时候',
  'pjshell.chat.subtitle':
    '进来就自动接上这个项目最近的那条会话。只带当前项目的上下文，不显示项目切换器，也看不到别的项目。',
  'pjshell.chat.open_full': '在 Lulu 完整打开',
  'pjshell.chat.attach': '附件',
  'pjshell.chat.attach.blocked': '这边还不能把文件发出去。',
  'pjshell.chat.voice.blocked': '这边还不能发语音。',
  'pjshell.task.subtitle': '谁在干什么、干到哪儿、写哪些文件。要你决定的排最上面。',
  'pjshell.task.search.placeholder': '搜任务名或文件路径',
  'pjshell.task.filter.all': '全部',
  'pjshell.task.filter.decide': '要你决定',
  'pjshell.task.filter.running': '正在跑',
  'pjshell.task.filter.failed': '失败',
  'pjshell.task.filter.done': '做完',
  'pjshell.task.filter.assignee': '负责人',
  'pjshell.task.filter.assignee.placeholder': '执行人或维护身份',
  'pjshell.task.filter.updated': '更新时间',
  'pjshell.task.filter.updated.any': '全部时间',
  'pjshell.task.filter.updated.hour': '最近 1 小时',
  'pjshell.task.filter.updated.today': '今天',
  'pjshell.task.filter.updated.week': '最近 7 天',
  'pjshell.task.sort.hint': '要你决定的排最前',
  'pjshell.task.col.name': '任务',
  'pjshell.task.col.source': '哪来的',
  'pjshell.task.col.who': '谁在做',
  'pjshell.task.col.state': '状态',
  'pjshell.task.col.elapsed': '用了多久',
  'pjshell.task.col.files': '写哪些文件',
  'pjshell.task.elapsed': '已经跑了 {elapsed}',
  'pjshell.task.stale': '已经没动静了',
  'pjshell.task.write': '正在改的文件',
  'pjshell.task.empty': '这个项目还没有开发任务。',
  'pjshell.resource.title': '这个项目用了什么',
  'pjshell.resource.subtitle': '独占的、共用的、公共池里借的，分开列。',
  'pjshell.resource.col.host': '机器',
  'pjshell.resource.col.owner': '归属',
  'pjshell.resource.col.env': '环境',
  'pjshell.resource.col.spec': '规格',
  'pjshell.resource.col.capacity': '容量',
  'pjshell.resource.col.expiry': '到期',
  'pjshell.resource.physical': '住着它的那台机器',
  'pjshell.resource.split': '拆出来的机器',
  'pjshell.resource.network': '网络',
  'pjshell.resource.address': '地址',
  'pjshell.resource.domain': '域名',
  'pjshell.resource.cert': '证书',
  'pjshell.resource.storage': '存储',
  'pjshell.resource.vendor': '供应商',
  'pjshell.overview.subtitle':
    '一眼看完：有没有人在干活、线上是哪个版本、有没有要你决定的事，以及导入时还差哪几项。',
  'pjshell.overview.health': '现在怎么样',
  'pjshell.overview.working': '现在有人在干活',
  'pjshell.overview.live_version': '线上在跑哪个版本',
  'pjshell.overview.last_release': '最近一次发布',
  'pjshell.overview.capacity': '机器和容量',
  'pjshell.capacity.host': '机器',
  'pjshell.capacity.cpu': 'CPU',
  'pjshell.capacity.memory': '内存',
  'pjshell.capacity.disk': '磁盘',
  'pjshell.overview.env': '测试和正式',
  'pjshell.overview.tasks': '任务',
  'pjshell.overview.release': '发布',
  'pjshell.overview.resource_issues': '资源异常',
  'pjshell.overview.takeover': '接管缺口',
  'pjshell.overview.events': '最近事件',
  'pjshell.overview.feed': '这几天谁动了这个项目',
  'pjshell.overview.no_resource_issue': '机器这边没有要处理的。',
  'pjshell.takeover.none': '这个项目不是接进来的，没有接管缺口。',
  'pjshell.memo.empty': '这个项目还没有备忘。',
  'pjshell.memo.voice.blocked': '项目备忘这边还不能录语音，写下来就能记在这个项目里。',
  'pjshell.release.checking': '校验中',
  'pjshell.release.publishing': '发布中',
  'pjshell.release.verifying': '验证中',
  'pjshell.release.live': '已上线',
  'pjshell.release.failed': '失败',
  'pjshell.release.none': '还没放过网页。',
  'pjshell.release.subtitle':
    '这个项目的应用和静态页面都在这儿。默认更新主站，不会偷偷建第二个站点。',
  'pjshell.release.sites': '这个项目的站点',
  'pjshell.release.step.check': '检查文件',
  'pjshell.release.step.publish': '发布',
  'pjshell.release.step.verify': '公网验证',
  'pjshell.release.step.verify.note': '我们自己访问一次才算数',
  'pjshell.release.step.live.note': '这时候才给网址',
  'pjshell.release.static': '静态页面 · 拖进来就发',
  'pjshell.release.steps': '四步都要真的走完',
  'pjshell.overview.now': '现在的状态',
  'pjshell.overview.watch': '要补的和要留意的',
  'pjshell.overview.decide': '有 {count} 件事要你决定',
  'pjshell.overview.decide.body': '要你决定的事排在最上面，其余按状态往下看。',
  'pjshell.overview.decide.action': '去处理',
  'pjshell.overview.go_tasks': '去任务页',
  'pjshell.overview.go_env': '去环境页',
  'pjshell.overview.go_release': '看发布历史',
  'pjshell.overview.go_resources': '去资源页',
  'pjshell.capacity.expiry': '到期',
  'pjshell.env.probe': '探测',
  'pjshell.env.machine': '机器',
  'pjshell.env.who': '谁能发',
  'pjshell.env.open': '打开网站',
  'pjshell.env.domains': '域名',
  'pjshell.chat.current': '当前会话',
  'pjshell.chat.split': '和一级 Lulu 的分工',
  'pjshell.chat.can.title': '这个框能做什么',
  'pjshell.chat.can.value': '简版 Lulu',
  'pjshell.chat.can.auto': '自动接上',
  'pjshell.chat.can.auto.body': '进来就是这个项目最近那条会话，不用挑',
  'pjshell.chat.can.send': '能发什么',
  'pjshell.chat.can.send.body': '文字、按住说话、拖附件进来',
  'pjshell.chat.can.assign': '交给 Agent',
  'pjshell.chat.can.assign.body': '@Claude、@Grok 直接点名，或让 Lulu 决定派谁',
  'pjshell.chat.can.status': '任务状态',
  'pjshell.chat.can.status.body': 'Agent 回复带真实状态，不是"正在思考"的占位',
  'pjshell.chat.cannot.title': '这个框不做什么',
  'pjshell.chat.cannot.value': '留给一级 Lulu',
  'pjshell.chat.cannot.switcher': '项目切换器',
  'pjshell.chat.cannot.switcher.body': '没有。要换项目回项目中心',
  'pjshell.chat.cannot.other': '别的项目',
  'pjshell.chat.cannot.other.body': '看不到，也搜不到——跨项目搜索走全局搜索',
  'pjshell.chat.cannot.manage': '会话管理',
  'pjshell.chat.cannot.manage.body': '新建、归档、多会话并排都在 Lulu 页',
  'pjshell.chat.cannot.orch': '多 Agent 编排',
  'pjshell.chat.cannot.orch.body': '完整的调度视图在 Lulu 页',
  'pjshell.resource.domains': '域名与入口',
  'pjshell.env.group': '两套环境',
  'pjshell.env.production.title': '正式 · 用户在用的',
  'pjshell.env.test.title': '测试 · 看效果用的',
  'pjshell.env.rollback': '回到上一版',
  'pjshell.env.col.point': '指向',
  'pjshell.env.col.resolve': '解析到',
  'pjshell.env.col.cert': '证书',
  'pjshell.env.col.expiry': '到期',
  'pjshell.env.col.state': '状态',
  'pjshell.overview.working.empty': '现在没有人在干活',
  'pjshell.overview.working.note':
    '时间是从任务真实开始算的，不是进度条。想看它具体在改哪些文件，点进任务。',
  'pjshell.overview.live.note': '能不能打开是真的去访问过一次得出的，不是根据发布成功推断的。',
  'pjshell.overview.feed.note': '按时间倒序 · 只放结果，过程在任务里',
  'pjshell.release.who': '谁发的',
  'pjshell.release.what': '内容',
  'pjshell.release.duration': '用时',
  'pjshell.release.previous': '上一次',
  'pjshell.release.version': '版本',
  'pjshell.release.app': '应用',
  'pjshell.release.today': '今天发了',
  'pjshell.release.rollbacks': '自动退回',
  'pjshell.resource.exclusive': '独占',
  'pjshell.resource.shared': '共用',
  'pjshell.resource.pool': '公共池借用',
  'pjshell.resource.col.entry': '域名 / 入口',
  'pjshell.resource.col.type': '类型',
  'pjshell.resource.col.point': '指向',
  'pjshell.resource.col.vendor': '服务商',
  'pjshell.resource.col.cert': '证书到期',
  'pjshell.resource.go_dns': '去环境页配置',
  'pjshell.resource.go_cert': '去发布页看证书',
  'pjshell.chat.context': '当前上下文：{name}',
  'pjshell.chat.placeholder': '说需求就行，比如「优惠券入口挪到金额下方」。@ 可以点名某个 Agent。',
  'pjshell.release.drop': '拖一个 HTML 或 ZIP 更新主站',
  'pjshell.release.drop.choose': '选择文件',
  'pjshell.release.drop.new_site': '另建一个站点',
  'pjshell.release.drop.hint': '默认更新 {slug}，要单独建站请明确点「另建一个站点」。',
  'pjshell.release.drop.empty': '这个项目还没有主站。拖进来会建第一个，不会偷偷建第二个。',
  'pjshell.release.primary_now': '当前主站 {slug} · v{version}',
  'pjshell.release.live_now': '线上现在是 v{version}',
  'pjshell.release.who_when': '{when} 由 {who} 发的，用了 {duration}',
  'pjshell.release.see_failure': '看为什么失败',
  'pjshell.release.progress': '看进度',
  'pjshell.release.open': '打开',
  'pjshell.release.replace': '换新版',
  'pjshell.release.col.url': '网址',
  'pjshell.release.col.name': '名字',
  'pjshell.release.col.version': '版本',
  'pjshell.release.col.status': '状态',
  'pjshell.release.col.last': '最近一次',
  'pjshell.release.col.size': '大小',
  'pjshell.release.col.actions': '操作',
  'pjshell.release.verifying.public': '公网验证中',
  'pjshell.release.app.title': '应用发布',
  'pjshell.release.app.subtitle': '先看线上事实，再看每次交付进入 main、部署和验证的结果。',
  'pjshell.release.tab.application': '应用版本',
  'pjshell.release.tab.static': '网页站点',
  'pjshell.release.summary': '这次发生了什么',
  'pjshell.release.change.title': '功能改动',
  'pjshell.release.change.impact': '影响范围',
  'pjshell.release.change.files': '提交内容',
  'pjshell.release.change.empty': '暂时读不到这次提交的变更摘要',
  'pjshell.release.change.truncated': '仅显示前 80 个文件',
  'pjshell.release.change.files_count': '{count} 个文件',
  'pjshell.release.change.binary': '二进制',
  'pjshell.release.change.affected_service': '受影响服务：{name}',
  'pjshell.release.change.area.console': 'Console 前端',
  'pjshell.release.change.area.database': '数据库',
  'pjshell.release.change.area.api_contract': 'API 契约',
  'pjshell.release.change.area.shared_packages': '共享组件',
  'pjshell.release.change.area.deployment': '部署配置',
  'pjshell.release.change.area.documentation': '文档',
  'pjshell.release.change.area.service': '{name} 服务',
  'pjshell.release.timing.total': '总耗时',
  'pjshell.release.timing.expected': '通常不超过 {duration}',
  'pjshell.release.timing.overdue': '已超过通常用时 {duration}，仍在处理',
  'pjshell.release.timing.seconds': '{seconds} 秒',
  'pjshell.release.timing.minutes': '{minutes} 分钟',
  'pjshell.release.timing.minutes_seconds': '{minutes} 分 {seconds} 秒',
  'pjshell.release.timing.hours': '{hours} 小时',
  'pjshell.release.timing.hours_minutes': '{hours} 小时 {minutes} 分',
  'pjshell.release.failure.code': '错误代码',
  'pjshell.release.technical': '技术详情',
  'pjshell.release.state.preparing': '正在准备',
  'pjshell.release.state.accepted': '已接收',
  'pjshell.release.state.building': '正在构建受影响服务',
  'pjshell.release.state.artifact_ready': '产物已就绪',
  'pjshell.release.state.needs_rebase': '需要基于新 main 重整',
  'pjshell.release.state.going_live': '正在上线',
  'pjshell.release.state.verifying': '正在验证',
  'pjshell.release.state.coalesced_live': '已随更新版本上线',
  'pjshell.release.production': '最近验证的生产版本',
  'pjshell.release.production.none': '还没有最近验证的生产版本',
  'pjshell.release.production.none.body': '没有完整回执时不会猜任何代码库的线上版本。',
  'pjshell.release.recent': '最近交付',
  'pjshell.release.empty': '暂无应用发布记录',
  'pjshell.release.empty.body': 'AI 快速发布完成一次接纳后，会在这里出现。',
  'pjshell.release.detail': '发布详情',
  'pjshell.release.detail.close': '关闭详情',
  'pjshell.release.detail.open': '查看发布详情',
  'pjshell.release.detail.stale': '详情未刷新',
  'pjshell.release.detail.stale.body': '当前显示列表中的最近快照，请稍后重试。',
  'pjshell.release.services': '受影响服务',
  'pjshell.release.services.none': '没有受影响服务',
  'pjshell.release.candidate': '候选提交',
  'pjshell.release.accepted_main': '已接纳候选',
  'pjshell.release.current_main': '当前 main',
  'pjshell.release.main_vs_production': '是否一致',
  'pjshell.release.main_vs_production.match': '一致',
  'pjshell.release.main_vs_production.mismatch': '不一致',
  'pjshell.release.main_vs_production.unknown': '未知',
  'pjshell.release.deployment': '部署提交',
  'pjshell.release.receipt': '制品回执',
  'pjshell.release.id': '发布编号',
  'pjshell.release.rollback_point': '回滚点',
  'pjshell.release.repository': '代码库',
  'pjshell.release.actor': '提交者 / Agent',
  'pjshell.release.updated': '最近更新',
  'pjshell.release.verified_at': '验证时间',
  'pjshell.release.coalesced_into': '随此版本交付',
  'pjshell.release.evidence': '生产证据',
  'pjshell.release.evidence.health': '健康检查',
  'pjshell.release.evidence.smoke': '核心业务验证',
  'pjshell.release.evidence.rollback': '回退准备',
  'pjshell.release.evidence.online': '线上业务',
  'pjshell.release.evidence.yes': '已确认',
  'pjshell.release.evidence.no': '未通过',
  'pjshell.release.evidence.unverified': '未核验',
  'pjshell.release.evidence.unknown': '未提供',
  'pjshell.release.state.candidate_ready': '代码已准备',
  'pjshell.release.badge.fast_candidate': '快送候选',
  'pjshell.release.badge.infra_fast': 'infra-fast',
  'pjshell.release.badge.verified_production': '已验证生产',
  'pjshell.release.lane.fast_candidates': '快送候选',
  'pjshell.release.lane.verified_production': '已验证生产',
  'pjshell.release.state.exact': '已进入 main',
  'pjshell.release.state.included': '已随更新版本进入 main',
  'pjshell.release.state.missing': '当前 main 不包含这次改动',
  'pjshell.release.state.deploying': '正在更新受影响服务',
  'pjshell.release.state.deployed': '服务已更新，正在验证',
  'pjshell.release.state.production_verified': '已上线并验证',
  'pjshell.release.state.delivered_in_successor': '已随更新版本上线',
  'pjshell.release.state.failed': '发布未完成',
  'pjshell.release.state.rolled_back': '已恢复到上一版本',
  'pjshell.release.failure.stage': '失败阶段',
  'pjshell.release.failure.stage.main': '进入 main',
  'pjshell.release.failure.stage.rebase': '进入 main',
  'pjshell.release.failure.stage.deploy': '更新服务',
  'pjshell.release.failure.stage.build': '构建产物',
  'pjshell.release.failure.stage.verification': '生产验证',
  'pjshell.release.failure.stage.rollback': '恢复上一版本',
  'pjshell.release.failure.reason': '原因',
  'pjshell.release.failure.file': '涉及路径',
  'pjshell.release.failure.action': '接下来怎么做',
  'pjshell.release.failure.action.rebase': '基于当前 main 重整候选后再发，不要 force。',
  'pjshell.release.failure.action.build': '同一提交不会重试，改代码后发新候选。',
  'pjshell.release.failure.action.verify': '新版本没有切到生产流量，先看旧版本是否仍在运行。',
  'pjshell.release.failure.action.main': '当前 main 不再包含这次改动，检查回滚或历史改写。',
  'pjshell.release.failure.action.bootstrap':
    '这是管理员恢复动作，不是第二种发布方式。运行中的发布器不能替换自己。',
  'pjshell.release.failure.bootstrap_label': '管理员恢复',
  'pjshell.release.failure.action.generic': '按失败阶段处理，不要把这次当成已上线。',
  'pjshell.release.failure.old_healthy': '线上仍运行上一版本',
  'pjshell.release.failure.old_unhealthy': '上一版本也未通过健康验证',
  'pjshell.release.failure.old_unknown': '无法确认线上状态',
  'pjshell.release.connection_lost': '暂时收不到最新状态',
  'pjshell.release.connection_lost.body':
    '下面保留最后一次从服务端取得的事实；连接恢复后会自动更新。',
  'pjshell.release.load_failed': '暂时无法读取应用发布事实',
  'pjshell.release.load_failed.body': '没有可靠数据时不会把应用发布显示成成功或空记录。',
  'pjshell.release.older': '更早的交付',
  'pjshell.release.older.loading': '正在读取更早的交付',
  'pjshell.release.step.candidate': '代码已准备',
  'pjshell.release.step.accepted': '接收候选',
  'pjshell.release.step.artifact_ready': '产物就绪',
  'pjshell.release.step.main': '进入 main',
  'pjshell.release.step.deploy_app': '更新受影响服务',
  'pjshell.release.step.production_verify': '生产验证',
  'pjshell.release.static.title': '静态网页',
  'pjshell.release.static.body': '上传 HTML 或 ZIP 的独立发布区，不影响上面的应用发布。',
  'pjshell.task.source.user': '你派的',
  'pjshell.task.source.lulu': 'Lulu',
  'pjshell.fact.unknown': '未知',
  'pjshell.resource.empty.title': '还没有关联主机',
  'pjshell.resource.empty.body':
    '这个项目还没挂机器。空闲机可以挂上来，也可以贴一台新的。没挂之前项目照样能写、能对话；要上线再找台机器。',
  'pjshell.resource.assign_idle': '挂上空闲机',
  'pjshell.resource.assign_to_project': '挂到这个项目',
  'pjshell.resource.add_one': '加一台',
  'pjshell.resource.unassign': '卸下',
  'pjshell.resource.unassign.title': '把这台从「{project_name}」卸下来？',
  'pjshell.resource.unassign.body':
    '卸下来它回到空闲池，巡检和告警不停。这个项目不再把它算成自己的。',
  'pjshell.resource.unassign.last_prod': '这是正式环境最后一台独占机。卸下来，线上就没地方住了。',
  'pjshell.resource.unassign.confirm': '卸下来',
  'pjshell.resource.col.actions': '操作',
  'pjshell.overview.card.lives': '住在哪儿',
  'pjshell.overview.card.entry': '对外入口',
  'pjshell.overview.card.publish': '发个网页',
} as const

export type PjshellId = keyof typeof PJSHELL

export function pj(id: PjshellId, vars?: Record<string, string>): string {
  if (lookup(id)) {
    return (t as (copyId: CopyId, copyVars?: Record<string, string>) => string)(id as CopyId, vars)
  }
  let text: string = PJSHELL[id]
  if (!vars) return text
  for (const [key, value] of Object.entries(vars)) {
    text = text.replaceAll(`{${key}}`, value)
  }
  return text
}
